import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cwhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
          <Sides/>
          <Helmet>
 
 <title>while loop statement in c tutorial For Beginners</title>
 <meta name="description" content="while loop in c tutorial for beginners.while loop in c is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,while loop in c,c programming tutorial for beginners,c while,c while loop,c while do,while statement in c,while loop c programming,while scanf,while c programming,while loop syntax in c,nested while loop in c,while loop example in c,while loop in c programming example ppt,while loop in c language" />
 <link rel="canonical" href="https://www.codeexampler.com/c-while" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">while loop statement in c</h1>
    <div className="first">
        <a href="/c-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">While loop C:</h2>
    <p className="mt-4 para">That condition work when the body of the loop executes until the given condition is false.</p>
   
  

<h2 className="headings">While loop C Syntax</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
                <span className="qwerty-6">while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-10">condition</span>
              <span className="qwerty-4">)</span>
                {"\n"}
              <span className="qwerty-4">&#123;</span>
                {"\n"} 
                    <span className="qwerty-3">  statement</span>
                <span className="qwerty-4">; </span>
                {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div>  




<h2 className="headings">Q-Write a program Increment in C while Loop Statement?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
                {"\n"}
              <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                <span className="qwerty-4" > &#123; </span>            
            {"\n"}
                <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> a</span>
                -<span className="qwerty-4">=</span>
                <span className="qwerty-1">1</span>
                <span className="qwerty-4">;</span>                
              {"\n"}
                <span className="qwerty-6">  while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#60;=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-4">)</span>
                {"\n"}
              <span className="qwerty-4">  &#123;</span>
                {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-10"> \n</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">);</span>
            {"\n"}
                    <span className="qwerty-5">   a</span>
                    <span className="qwerty">++</span>
                    <span className="qwerty-4">;</span>                   
                              {"\n"}
                    <span className="qwerty-8">     OR</span>
                              {"\n"}
                    <span className="qwerty-5">   a</span>
                    <span className="qwerty-4">=</span>
                    <span className="qwerty-5">a</span>
                    <span className="qwerty">+</span>
                    <span className="qwerty-1">1</span>
                    <span className="qwerty-4">;</span>                   
                              {"\n"}
              <span className="qwerty-4">  &#125;</span>
              {"\n"}
              <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>  
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-1">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-1">4</span>                   
                  {"\n"}         
                  <span className="qwerty-1">5</span>                   
                  {"\n"}         
                  <span className="qwerty-1">6</span>                   
                  {"\n"}         
                  <span className="qwerty-1">7</span>                   
                  {"\n"}         
                  <span className="qwerty-1">8</span>                   
                  {"\n"}         
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-1">10</span>                   
                  {"\n"}         
                </code>
                </pre>
                </div> 




<h2 className="headings">Q-Write a program Decrement or Subtract in C while Loop Statement?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
                                        {"\n"}
              <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                <span className="qwerty-4" > &#123; </span>            
            {"\n"}
                <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> a</span>
                -<span className="qwerty-4">=</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">;</span>                
              {"\n"}
                <span className="qwerty-6">  while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#62;=</span>
              <span className="qwerty-1">1</span>
              <span className="qwerty-4">)</span>
                {"\n"}
              <span className="qwerty-4">  &#123;</span>
                {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-10"> \n</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5"> a</span>
                <span className="qwerty-4">);</span>
            {"\n"}
                    <span className="qwerty-5">   a</span>
                    <span className="qwerty">--</span>
                    <span className="qwerty-4">;</span>                   
                              {"\n"}
                    <span className="qwerty-8">     OR</span>
                              {"\n"}
                    <span className="qwerty-5">   a</span>
                    <span className="qwerty-4">=</span>
                    <span className="qwerty-5">a</span>
                    <span className="qwerty">-</span>
                    <span className="qwerty-1">1</span>
                    <span className="qwerty-4">;</span>                   
                              {"\n"}
              <span className="qwerty-4">  &#125;</span>
              {"\n"}
              <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>  
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">10</span>                   
                  {"\n"}          
                  <span className="qwerty-1">9</span>                   
                  {"\n"}         
                  <span className="qwerty-1">8</span>                   
                  {"\n"}          
                  <span className="qwerty-1">7</span>                   
                  {"\n"}          
                  <span className="qwerty-1">6</span>                   
                  {"\n"}          
                  <span className="qwerty-1">5</span>                   
                  {"\n"}          
                  <span className="qwerty-1">4</span>                   
                  {"\n"}          
                  <span className="qwerty-1">3</span>                   
                  {"\n"}          
                  <span className="qwerty-1">2</span>                   
                  {"\n"}          
                  <span className="qwerty-1">1</span>                   
                  {"\n"}       
                  {"\n"}       
                </code>
                </pre>
                </div> 




<h2 className="headings">while loop uses logic operator Example:</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
                <span className="qwerty-6">while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#60;=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-3"> &amp;&amp; </span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#62;=</span>
              <span className="qwerty-1">1</span>
               <span className="qwerty-4">)</span>
                {"\n"}              
                <span className="qwerty-6">while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#60;=</span>
              <span className="qwerty-1">10</span>
              <span className="qwerty-3"> || </span>
              <span className="qwerty-5">a</span>
              <span className="qwerty">&#62;=</span>
              <span className="qwerty-1">1</span>
               <span className="qwerty-4">)</span>
                {"\n"}
                {"\n"}
               </code>
          </pre>
        </div>  

<h2 className="mt-4 mh2">While loop Reverse C</h2>


<h2 className="headings">Q-Write a program to input an integer number and print in reverse in C programming?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
                                        {"\n"}
              <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                <span className="qwerty-4" > &#123; </span>            
            {"\n"}
                <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> n</span>
                <span className="qwerty-4">;</span>
                              {"\n"}              
              <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-5">Enter a no</span>
                <span className="qwerty-4">");</span>
              {"\n"}
              <span className="qwerty-6">  scanf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-1">&amp;</span>
                <span className="qwerty-5">n</span>
                <span className="qwerty-4">);</span>
              {"\n"}
                <span className="qwerty-6">  while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">n</span>
              <span className="qwerty">&#62;</span>
              <span className="qwerty-1">0</span>
              <span className="qwerty-4">)</span>
                {"\n"}
              <span className="qwerty-4">  &#123;</span>
                {"\n"}
                <span className="qwerty-8">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-5">n</span>
                <span className="qwerty">%</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">);</span>
            {"\n"}
                <span className="qwerty-5">   n</span>
                <span className="qwerty-4"> =</span>
                <span className="qwerty-5"> n</span>
                <span className="qwerty">/</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">);</span>
            {"\n"}
              <span className="qwerty-4">  &#125;</span>
              {"\n"}            
              <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>  
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter a no </span>                   
                  <span className="qwerty-1">2468</span>                   
                  {"\n"}         
                  <span className="qwerty-3">8642</span>                  
                  {"\n"}                            
                  {"\n"}         
                </code>
                </pre>
                </div> 


<p className="mt-4 para">If you don't know about input in C so check on the <a href="https://www.codeexampler.com/c-input">C input tutorial</a>.</p>



<h2 className="headings">Q-Write a program to input found out the sum of digits of integer no?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
                                        {"\n"}
              <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
            {"\n"}
                <span className="qwerty-4" > &#123; </span>            
            {"\n"}
                <span className="qwerty-3">  int</span>
                <span className="qwerty-5"> n</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-5"> sum</span>
                -<span className="qwerty-4">=</span>
                <span className="qwerty-1">0</span>
                <span className="qwerty-4">,</span>                
                <span className="qwerty-5"> d</span>
                <span className="qwerty-4">;</span>                
              {"\n"}              
              <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-5">Enter a no</span>
                <span className="qwerty-4">");</span>

              {"\n"}

                <span className="qwerty-6">  while</span>
              <span className="qwerty-4"> (</span>
              <span className="qwerty-5">n</span>
              <span className="qwerty">&#62;</span>
              <span className="qwerty-1">0</span>
              <span className="qwerty-4">)</span>
                {"\n"}
              <span className="qwerty-4">  &#123;</span>
                {"\n"}
                <span className="qwerty-5">   sum</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-5"> sum</span>
                <span className="qwerty">+</span>
                <span className="qwerty-5"> n</span>
                <span className="qwerty">%</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">);</span>
            {"\n"}
                <span className="qwerty-5">   n</span>
                <span className="qwerty-4"> =</span>
                <span className="qwerty-5"> n</span>
                <span className="qwerty">/</span>
                <span className="qwerty-1">10</span>
                <span className="qwerty-4">);</span>
            {"\n"}
              <span className="qwerty-4">  &#125;</span>
              {"\n"}
              <span className="qwerty-8">  printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-10">sum of digit =</span>
                <span className="qwerty-3"> %d</span>                
                <span className="qwerty-4">",</span>
                <span className="qwerty-5">sum</span>
                <span className="qwerty-4">);</span>
            {"\n"}
               
              <span className="qwerty-7">  return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}
              <span className="qwerty-4">&#125;</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>  
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter a no </span>                   
                  <span className="qwerty-1">2468</span>                   
                  {"\n"}         
                  <span className="qwerty-5">sum of digit</span>                  
                  <span className="qwerty-4">=</span>                  
                  <span className="qwerty-1"> 20</span>                   
                  {"\n"}                            
                  {"\n"}         
                </code>
                </pre>
                </div> 

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-looping">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-do-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cwhile;